@if (questionItems().length) {
  <odl-button [description]="'HEADER.QUESTIONS' | translate" id="header-questions-button">
    <odl-icon name="question_list" slot="only-icon" />
    <div
      class="button-badge"
      [class.button-badge--admin]="isAdmin()"
      [class.button-badge--checked]="isCheckedStudent()"
    >
      @if (isCheckedStudent()) {
        <odl-icon name="check" slot="only-icon" />
      } @else {
        {{ questionItems().length }}
      }
    </div>
  </odl-button>
  <odl-tooltip for="#header-questions-button">{{ 'HEADER.QUESTIONS' | translate }}</odl-tooltip>
  <odl-menu for="#header-questions-button" placement="top-start">
    @for (item of questionItems(); track item.id) {
      <odl-menu-item (odl-select)="openSelectedItem(item.id)">
        <div class="question-list__icon-wrapper" slot="icon">
          <odl-icon [name]="item.icon"></odl-icon>
          @if (item.hasPending) {
            <span class="question-list__dot"></span>
          }
        </div>
        <span>{{ item.label }}</span>
      </odl-menu-item>
    }
  </odl-menu>
}
